import React from 'react';

import { BookingsList } from '../components/BookingsList';

import { PageShell } from '@/components/page-shell';

/**
 * Ticketing > Hotels.
 *
 * Every stay really booked with the property - confirmed straight through,
 * or confirmed by an admin from the hold queue - and whatever became of it
 * since. Read-only: the decisions live on Action needed and on the booking.
 */
export const TicketingHotelsPage = (): React.JSX.Element => (
  <PageShell
    title="Hotels"
    description="Hotel bookings made with the property, including the ones an admin confirmed from the hold queue. Filter by status to see cancellations and refunds."
  >
    <BookingsList gridId="ticketing-hotels" variant="booked" product="HOTEL" />
  </PageShell>
);
